import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5e9e9163"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "navigation-item" };
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskNavigationItem',
    props: {
        navigationMenuItem: {}
    },
    setup(__props) {
        const { navigationMenuItem } = __props;
        const store = useStore();
        const router = useRouter();
        const selectedNavigationItem = computed(() => store.getters.getSelectedNavLink);
        const navigationItemClassName = computed(() => "navigation-item-wrapper" + (navigationMenuItem.code === selectedNavigationItem.value ? " navigation-item-wrapper-selected" : ""));
        const visitRoute = () => router.push({ name: navigationMenuItem.code });
        const iconPerItemSlugDictionary = {
            "home": "pi pi-fw pi-home",
            "inventory": "pi pi-fw pi-sitemap",
            "load-testing": "pi pi-fw pi-chart-line",
            "page-performance": "pi pi-fw pi-chart-bar",
            "accessibility": "pi pi-fw pi-eye",
            "seo": "pi pi-fw pi-search",
        };
        const navigationItemIcon = computed(() => {
            return iconPerItemSlugDictionary[navigationMenuItem.code];
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                "data-testid": "navigation-item",
                class: _normalizeClass(navigationItemClassName.value),
                onClick: _cache[0] || (_cache[0] = ($event) => (visitRoute()))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("i", {
                        class: _normalizeClass(navigationItemIcon.value)
                    }, null, 2),
                    _createElementVNode("span", null, _toDisplayString(_ctx.navigationMenuItem.label), 1)
                ])
            ], 2));
        };
    }
});
